import { toast } from 'react-toastify';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { mergeMap, switchMap } from 'rxjs/operators';

import {
  AddMySelfFailure,
  AddMySelfSuccess,
  EditMySelfFailure,
  EditMySelfSuccess,
} from '../../Redux/Actions/MySelfAction';
import { ADD_MYSELF, EDIT_MYSELF } from '../../Redux/Actiontype';
import routeRules from '../../Routes/routeRules';
import history from '../../Store/history';
import { Basepath } from '../../config';

const clearSession = msg => {
  localStorage.clear();
  alert(msg);
  window.location = '/';
};
export const AddMySelfEpic = action$ =>
  action$.pipe(
    ofType(ADD_MYSELF),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/addMySelf`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              history.push(routeRules.hobbiesmanagement, toast.success(response.response.message));
              return of(AddMySelfSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              console.log(response.response);
              return of(AddMySelfFailure(response.response));
            }
          }),
        ),
    ),
  );
export const EditMySelfEpic = action$ =>
  action$.pipe(
    ofType(EDIT_MYSELF),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/editMySelf`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(EditMySelfSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(EditMySelfFailure(response.response));
            }
          }),
        ),
    ),
  );
